<script setup lang="ts">
import { Image } from '@/components';
import { useFavoriteFabric } from './use-favorite-fabric.ts';
import { useRouter } from 'vue-router';
import type { FavoriteItem } from '@/views/favorite/typing.ts';
import { useParamStore } from '@/store/param.ts';
import { List } from 'vant';

const { results } = useFavoriteFabric();

const router = useRouter();
const { refreshLoadResourceByRoute } = useParamStore();

const onClick = async (item: FavoriteItem) => {
  const lastRoute = JSON.parse(localStorage.getItem('lastRoute') || '{}');
  await router.replace({
    name: 'fabric', query: {
      ...lastRoute.query
    },
    params: {
      type: item.resourceType,
      id: item.fabricId
    }
  });
  await refreshLoadResourceByRoute();
};

</script>

<template>
  <List
    :class="$style.listContainer"
    :finished="true"
    finished-text="没有更多了"
    :immediate-check="false"
  >
    <div :class="$style.cardList">
      <div
        :class="$style.card"
        v-for="item of results"
        :key="item.id"
        @click="onClick(item)"
      >
        <Image
          :src="item.thumb||''"
          lazy-load
          :height="200"
          fit="scale-down"
        />
        <div :class="$style.name">
          {{ item.info?.name || item.id }}
        </div>
      </div>
    </div>
  </List>

</template>

<style module>
.listContainer {
  height: 100%;
  overflow-y: auto;
}

.cardList {
  display: grid;
  grid-template-columns: 1fr 1fr;
  grid-template-rows: minmax(230px, auto) 1fr;
}

.cardList:empty {
  height: 0;
}

.card {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  width: 100%;
  padding: 10px;
}

.name {
  padding: 0 10px;
}
</style>

